<template>
	<div class="share-buttons">
		<Button
			v-if="facebookText"
			level="primary"
			icon="facebook"
			small
			type="button"
			@click.prevent="onShare('facebook')"
		/>
		<Button
			v-if="twitterText"
			level="primary"
			icon="twitter"
			small
			type="button"
			@click.prevent="onShare('twitter')"
		/>
		<Button
			v-if="whatsappText"
			level="primary"
			icon="whatsapp"
			small
			type="button"
			@click.prevent="onShare('whatsapp')"
		/>
		<Button
			v-if="emailText"
			level="primary"
			icon="envelope"
			small
			type="button"
			@click.prevent="onShare('email')"
		/>
	</div>
</template>

<script>
import Button from '@/components/Button'

export default {
	components: {
		Button,
	},
	props: {
		emailSubject: String,
		emailText: String,
		facebookText: String,
		twitterText: String,
		whatsappText: String,
		url: String,
	},
	data() {
		return {
			shareUrls: {
				facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
				twitter: 'https://twitter.com/intent/tweet?text=',
				whatsapp: 'https://api.whatsapp.com/send?text=',
				email: 'mailto:',
			}
		};
	},
	computed: {},
	methods: {
		onShare(share) {
			let shareUrl = this.shareUrls[share];

			if (share == 'email') {
				window.location.href = `${shareUrl}?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(this.emailText)}`;
				return;
			}
			else if (share == 'facebook') {
				shareUrl += `${encodeURIComponent(this.url)}&text=${encodeURIComponent(this.facebookText)}`;
			}
			else if (share == 'twitter') {
				shareUrl += `${encodeURIComponent(this.twitterText)}`;
			}
			else if (share === 'whatsapp') {
				shareUrl += `${encodeURIComponent(this.whatsappText)}`;
			}

			window.open(shareUrl, 'share', 'width=600,height=472');
		}
	}
}
</script>